import axios from 'axios';
import { AuthUtil } from './auth-util';
var CustomAxios = axios.create({
    baseURL: AuthUtil.BACK_END_URL,
    headers: {
        "Content-Type": "application/json",
    },
});
CustomAxios.interceptors.request.use(function (config) {
    var token = AuthUtil.getToken();
    if (token) {
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    return config;
}, function (error) { return Promise.reject(new Error(error)); });
var toCamelCase = function (object) {
    var transformedObject = object;
    if (typeof object === "object" && object !== null) {
        if (object instanceof Array) {
            transformedObject = object.map(toCamelCase);
        }
        else {
            transformedObject = {};
            for (var key in object) {
                if (object[key] !== undefined) {
                    var newKey = key.replace(/(_\w)|(-\w)/g, function (k) { return k[1].toUpperCase(); });
                    transformedObject[newKey] = toCamelCase(object[key]);
                }
            }
        }
    }
    return transformedObject;
};
export var toSnackCase = function (object) {
    var transformedObject = object;
    if (typeof object === "object" && object !== null) {
        if (object instanceof Array) {
            transformedObject = object.map(toSnackCase);
        }
        else {
            transformedObject = {};
            for (var key in object) {
                if (object[key] !== undefined) {
                    var newKey = key
                        .replace(/\.?([A-Z]+)/g, function (_, y) {
                        return "_" + y.toLowerCase();
                    })
                        .replace(/^_/, "");
                    transformedObject[newKey] = toSnackCase(object[key]);
                }
            }
        }
    }
    return transformedObject;
};
CustomAxios.interceptors.response.use(function (response) {
    var isBlob = response.data instanceof Blob;
    var contentType = response.headers['content-type'];
    var isPdf = typeof contentType === 'string' && contentType.includes('application/pdf');
    if (!isBlob && !isPdf) {
        response.data = toCamelCase(response.data);
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});
CustomAxios.interceptors.request.use(function (config) {
    config.data = toSnackCase(config.data);
    return config;
}, function (error) {
    return Promise.reject(error);
});
export default CustomAxios;
